import Vue from 'vue'
import App from './App.vue'

// import {BootstrapVue} from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.min.css"
// import "bootstrap-vue/dist/bootstrap-vue.css"

// Vue.use(BootstrapVue)

export const eventBus = new Vue({
	data: {
		name: 'HCN Web',
		events: {
			mountLogin: '0',
		},
	},

	methods: {
		mountLogin() {
			this.$emit(this.events.mountLogin, null);
		}
	},
});

new Vue({
	el: '#app',
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js